<ng-container [ngSwitch]="true">
  <ng-container *ngSwitchCase="type === 'image' && imageSrc && true">
    <img #image [src]="imageSrc" [ngStyle]="imageStyles"
  /></ng-container>

  <ng-container *ngSwitchCase="type === 'image-with-container' && imageSrc && true">
    <div
      class="image-container"
      [ngStyle]="imageStyles"
      [style.background-image]="'url(' + imageSrc + ')'"
    ></div
  ></ng-container>

  <ng-container *ngSwitchCase="type === 'initials' && fullName && true">
    <div
      #avatarPlaceholder
      class="avatar-placeholder"
      [class.bg-light]="backgroundColor === 'light'"
      [class.bg-gray]="backgroundColor === 'gray'"
      [class.bg-light-gray]="backgroundColor === 'light-gray'"
      [class.bg-green]="backgroundColor === 'green'"
      [class.font-size-backend-style]="fontSize === 'small'"
      [class.colorized]="isColorized"
    >
      <div class="initials">{{ nameInitials }}</div>
    </div></ng-container
  >

  <ng-container *ngSwitchCase="type === 'icon' && iconName && true">
    <div class="avatar-icon" [class.light]="isIconLight">
      <rt-icon [name]="iconName" [isLight]="isIconLight" [size]="iconSize"></rt-icon>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="type === 'custom' && avatarTpl && true">
    <ng-container *ngTemplateOutlet="avatarTpl!"></ng-container>
  </ng-container>
</ng-container>

<div *ngIf="isOnline" class="online-indicator"></div>

<div *ngIf="hasUnreadNotifications" class="has-notifications">
  <ng-container *ngTemplateOutlet="tooltipTplRef"></ng-container>
</div>
